module.exports = __webpack_public_path__ + "static/media/inicioChatTransp.5cbd114a.png";